import { TemplateChangePlan } from "./template-change-plan";

export const TemplateGrow = (accounting, grow, requester) =>
    TemplateChangePlan({ type: "Grow", accounting, request: grow, requester });
